import { createActions } from 'redux-actions';

const actions = createActions({
  USER: {
    SEND_INVITATIONS: (invitationData) => ({ invitationData })
  }
})

const configuration = {
  name: 'sendInvitations',
  action: actions,
  sagas: undefined,
  reducers: {

  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/sendInvitations.js